module.exports = __webpack_public_path__ + "img/霞洞上河贡园1.fd82fda2.png";